"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemBase = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var DashboardItemContent_1 = require("./DashboardItemContent");
var DashboardItemContentWrapper_1 = require("./DashboardItemContentWrapper");
exports.DashboardItemBase = function (_a) {
    var children = _a.children, contentClassName = _a.contentClassName, visualizationClassName = _a.visualizationClassName, _b = _a.renderHeadline, renderHeadline = _b === void 0 ? function () { return null; } : _b, _c = _a.renderBeforeVisualization, renderBeforeVisualization = _c === void 0 ? function () { return null; } : _c, _d = _a.renderAfterVisualization, renderAfterVisualization = _d === void 0 ? function () { return null; } : _d, _e = _a.renderBeforeContent, renderBeforeContent = _e === void 0 ? function () { return null; } : _e, _f = _a.renderAfterContent, renderAfterContent = _f === void 0 ? function () { return null; } : _f, contentRef = _a.contentRef;
    return (react_1.default.createElement(DashboardItemContentWrapper_1.DashboardItemContentWrapper, null, function (_a) {
        var clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderBeforeContent(),
            react_1.default.createElement(DashboardItemContent_1.DashboardItemContent, { className: contentClassName, ref: contentRef },
                renderBeforeVisualization(),
                react_1.default.createElement("div", { className: visualizationClassName },
                    renderHeadline(clientHeight),
                    children({ clientWidth: clientWidth, clientHeight: clientHeight })),
                renderAfterVisualization()),
            renderAfterContent()));
    }));
};
//# sourceMappingURL=DashboardItemBase.js.map